import { DeploymentSummary } from "@/generated";
import { useChannelMeta } from "@/components/AppManagementV2/useChannelMeta";
import Image from "next/image";

const MAX_VISIBLE = 3;

export const DeploymentsStack = ({
  deployments,
}: {
  deployments?: DeploymentSummary[];
}) => {
  const channelMeta = useChannelMeta();

  const active = deployments?.filter((d) => d.is_active) ?? [];
  if (active.length === 0) return null;

  const visible = active.slice(0, MAX_VISIBLE);
  const overflow = active.length - MAX_VISIBLE;

  return (
    <div className="flex gap-1 items-center">
      {visible.map((deployment) => {
        const meta = channelMeta[deployment.channel_type];
        const iconUrl = meta?.icon;

        return (
          <div
            className="flex items-center justify-center p-1 rounded-md bg-muted"
            key={deployment.id}
            title={meta?.label ?? deployment.channel_type}
          >
            <div className="relative h-4 w-4">
              {iconUrl ? (
                <Image
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={iconUrl}
                  alt={meta?.label ?? deployment.channel_type}
                  fill
                />
              ) : null}
            </div>
          </div>
        );
      })}
      {overflow > 0 && (
        <span className="text-xs text-muted-foreground font-medium px-1">
          +{overflow} more
        </span>
      )}
    </div>
  );
};
